var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row not-found center-xs middle-xs"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.alert))]),_vm._v(" Você será redirecionado para a página inicial em "+_vm._s(this.count)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }